import React, { useState } from 'react';
import { _T, C, CSS } from '../../shared/theme';
import { s_PB, s_GB, s_GC, s_TI, s_PL } from '../../shared/styles';
import { t } from '../../shared/i18n';

function WeeklyIntention({lang,onDone}) {
  const nl = lang==="nl";
  const [selected, setSelected] = useState(null);
  const [custom, setCustom] = useState("");
  const [showCustom, setShowCustom] = useState(false);

  const INTENTION_EXAMPLES = [
    {
      category: nl?"Mentale Focus":"Mental Focus",
      icon:"🎯", color:"#D4873A",
      options: nl
        ? ["Rustiger reageren op stress","Minder afgeleid zijn tijdens werk","Beter één ding tegelijk doen","Bewuster omgaan met mijn aandacht"]
        : ["React more calmly to stress","Stay less distracted at work","Do one thing at a time","Be more intentional with attention"]
    },
    {
      category: nl?"Lichaamsbewustzijn":"Body Awareness",
      icon:"💪", color:"#C06090",
      options: nl
        ? ["Meer luisteren naar mijn lichaam","Spanning eerder herkennen","Bewuster bewegen door de dag","Beter voelen wanneer ik rust nodig heb"]
        : ["Listen more to my body","Recognise tension earlier","Move more consciously through the day","Better sense when I need rest"]
    },
    {
      category: nl?"Emotieregulatie":"Emotion Regulation",
      icon:"❤️", color:"#C05050",
      options: nl
        ? ["Minder snel overweldigd raken","Emoties herkennen voor ik reageer","Rustiger blijven onder druk","Meer verbinding met mijn gevoel"]
        : ["Get overwhelmed less quickly","Recognise emotions before reacting","Stay calmer under pressure","More connection with my feelings"]
    },
    {
      category: nl?"Rust & Herstel":"Rest & Recovery",
      icon:"🌿", color:"#2A9E82",
      options: nl
        ? ["Beter ontspannen na een drukke dag","Meer kwalitatieve slaap","Eerder stoppen met schermen","Herstel inbouwen in mijn dag"]
        : ["Relax better after a busy day","Get more quality sleep","Stop screens earlier","Build recovery into my day"]
    },
    {
      category: nl?"Intuïtieve Waarneming":"Intuitive Perception",
      icon:"🔮", color:"#7B6FD0",
      options: nl
        ? ["Meer vertrouwen op mijn gevoel","Bewuster zijn van eerste indrukken","Minder analyseren, meer voelen","Aanwezig zijn in het moment"]
        : ["Trust my feelings more","Be more aware of first impressions","Less analysing, more feeling","Be present in the moment"]
    },
    {
      category: nl?"Tijdsbewustzijn":"Time Awareness",
      icon:"⏱️", color:"#2A9E82",
      options: nl
        ? ["Bewuster omgaan met mijn tijd","Minder gehaast voelen","Flow momenten vaker ervaren","Beter inschatten hoeveel tijd iets kost"]
        : ["Be more intentional with my time","Feel less rushed","Experience flow states more often","Better estimate how long things take"]
    },
    {
      category: nl?"Sociale Focus":"Social Focus",
      icon:"👥", color:"#5B9ED0",
      options: nl
        ? ["Beter luisteren in gesprekken","Meer aanwezig zijn bij anderen","Grenzen duidelijker voelen","Meer empathie in contact"]
        : ["Listen better in conversations","Be more present with others","Feel boundaries more clearly","More empathy in interactions"]
    },
  ];

  const allSelected = selected || (custom.trim() ? custom.trim() : null);

  return (
    <div style={{minHeight:"100vh",background:`linear-gradient(160deg,${_T.bg},${_T.bg2})`,display:"flex",flexDirection:"column",padding:24,paddingTop:52}}>
      <style>{CSS}</style>
      <div style={{fontFamily:"Georgia,serif",fontSize:22,color:C.white,marginBottom:6}}>{t("intention.title",lang)}</div>
      <div style={{color:C.silver,fontSize:13,marginBottom:20,lineHeight:1.6,fontWeight:300}}>
        {t("intention.subtitle",lang)}
      </div>

      <div style={{flex:1,overflowY:"auto",paddingBottom:20}}>
        {INTENTION_EXAMPLES.map(group=>(
          <div key={group.category} style={{marginBottom:18}}>
            <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:8}}>
              <div style={{width:24,height:24,borderRadius:6,background:`${group.color}25`,border:`1px solid ${group.color}44`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:13}}>{group.icon}</div>
              <div style={{fontSize:13,color:group.color,fontWeight:700,letterSpacing:2}}>{group.category.toUpperCase()}</div>
            </div>
            <div style={{display:"flex",flexDirection:"column",gap:6}}>
              {group.options.map(opt=>{
                const isSelected = selected===opt;
                return (
                  <button key={opt} onClick={()=>{setSelected(isSelected?null:opt);setShowCustom(false);setCustom("");}}
                    style={{background:isSelected?`${group.color}18`:_T.bg3,borderTop:`1.5px solid ${isSelected?group.color:_T.cardBorderTop}`,borderBottom:`1px solid ${_T.cardBorderBot}`,borderLeft:`1px solid ${isSelected?group.color+"44":"rgba(255,255,255,0.04)"}`,borderRight:"1px solid rgba(255,255,255,0.04)",borderRadius:14,padding:"11px 14px",color:isSelected?C.white:C.silver,fontSize:13,cursor:"pointer",textAlign:"left",display:"flex",alignItems:"center",gap:10,transition:"all 0.15s"}}>
                    <div style={{width:14,height:14,borderRadius:"50%",flexShrink:0,background:isSelected?group.color:"transparent",border:`2px solid ${isSelected?group.color:_T.cardBorderBot}`,transition:"all 0.15s"}}/>
                    {opt}
                  </button>
                );
              })}
            </div>
          </div>
        ))}

        {/* Custom option */}
        <div style={{marginBottom:16}}>
          <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:8}}>
            <div style={{width:24,height:24,borderRadius:6,background:`${C.silver}15`,border:`1px solid ${C.silver}33`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:13}}>✏️</div>
            <div style={{fontSize:13,color:C.silver,fontWeight:700,letterSpacing:2}}>{t("intention.custom_label",lang)}</div>
          </div>
          {!showCustom
            ? <button onClick={()=>{setShowCustom(true);setSelected(null);}} style={{background:_T.bg3,borderTop:`1.5px solid ${_T.cardBorderTop}`,borderBottom:`1px solid ${_T.cardBorderBot}`,borderLeft:"1px solid rgba(255,255,255,0.04)",borderRight:"1px solid rgba(255,255,255,0.04)",borderRadius:14,padding:"11px 14px",color:C.silver,fontSize:13,cursor:"pointer",textAlign:"left",width:"100%",display:"flex",alignItems:"center",gap:10}}>
                <div style={{width:14,height:14,borderRadius:"50%",background:"transparent",border:`2px solid ${_T.cardBorderBot}`,flexShrink:0}}/>
                {t("intention.custom_btn",lang)}
              </button>
            : <div style={{borderRadius:14,border:`1.5px solid ${_T.accent}`,overflow:"hidden"}}>
                <textarea value={custom} onChange={e=>setCustom(e.target.value)} placeholder={t("intention.custom_ph",lang)} autoFocus style={{...s_TI({minHeight:70,resize:"none",borderRadius:0,border:"none",padding:"12px 14px",fontSize:13,lineHeight:1.6})}}/>
              </div>
          }
        </div>
      </div>

      <button
        style={s_PB({opacity:allSelected?1:0.4,width:"100%",fontSize:15,padding:"15px",flexShrink:0})}
        disabled={!allSelected}
        onClick={()=>allSelected&&onDone(allSelected)}>
        {t("common.continue",lang)}
      </button>
      <div style={{display:"flex",justifyContent:"center",gap:20,paddingTop:16,paddingBottom:4,flexShrink:0}}>
        <a href="/privacy" style={{color:"#3a4a62",fontSize:11,textDecoration:"none"}}>Privacy Policy</a>
        <a href="/terms" style={{color:"#3a4a62",fontSize:11,textDecoration:"none"}}>Terms &amp; Conditions</a>
      </div>
    </div>
  );
}

export default WeeklyIntention;
